import type { CqWifiTicket } from '../api/connectionQuality'
import './CqWifi.css'

/**
 * Starea Wi-Fi a aparatului inainte de tichet (instantaneul din
 * TicketConnection.php): AP-ul, semnalul, banda si cate deconectari si
 * roamuri au fost in cele 30 de minute. Pe cablu nu apare.
 */
const SIGNAL_TEXT = { good: 'good', fair: 'fair', weak: 'weak', poor: 'very weak' } as const

export function TicketWifiLine({ wifi }: { wifi: CqWifiTicket }) {
  const parts: string[] = []
  if (wifi.rssi_dbm !== null) parts.push(`${Math.round(wifi.rssi_dbm)} dBm${wifi.signal ? ` (${SIGNAL_TEXT[wifi.signal]})` : ''}`)
  if (wifi.band) parts.push(`${wifi.band} GHz${wifi.channel !== null ? `, channel ${wifi.channel}` : ''}`)
  parts.push(wifi.ap ? `AP ${wifi.ap.label}` : wifi.bssid_ok ? 'AP unknown' : 'AP unknown (location off)')
  parts.push(wifi.disconnects === 1 ? '1 disconnect' : `${wifi.disconnects} disconnects`)
  if (wifi.roams > 0) parts.push(wifi.roams === 1 ? '1 roam' : `${wifi.roams} roams`)

  return (
    <div className={`cq-wifi-ticket${wifi.disconnects > 0 || wifi.signal === 'weak' || wifi.signal === 'poor' ? ' is-bad' : ''}`} data-section="wifi">
      <i className="fas fa-wifi" aria-hidden="true"></i> <strong>Wi-Fi{wifi.ssid ? ` ${wifi.ssid}` : ''}:</strong> {parts.join(' · ')}
    </div>
  )
}
